// Clerk Account Portal entry points.
//
// We send users to Clerk's hosted sign-in/sign-up pages instead of embedding the
// <SignIn/> widget on /login. The hosted portal handles every Clerk flow (incl.
// second factors) correctly, whereas the embedded widget was stalling on the
// email-code second-factor step.
//
// Both the portal host and the post-login origin are environment-specific so each
// deploy targets its own Clerk instance (prod → its prod instance, staging → a
// dev instance, etc.) rather than always bouncing to prod:
//   - VITE_CLERK_ACCOUNT_PORTAL — the hosted portal host for this env's instance
//   - VITE_PUBLIC_ORIGIN        — the origin we bounce back to after auth
// Values live in web/.env.* and can be overridden per deploy via Railway build
// vars (see Dockerfile). Vite statically inlines import.meta.env.* at build time,
// so the pre-rendered SSG HTML and the client render stay byte-identical — no
// `window` read in production, no hydration mismatch (React #418).
const ACCOUNT_PORTAL = import.meta.env.VITE_CLERK_ACCOUNT_PORTAL

function portalUrl(path: '/sign-in' | '/sign-up'): string {
  // In local dev the origin isn't fixed (localhost:<port>), so read it live so
  // the bounce returns to your dev server. `import.meta.env.DEV` is statically
  // replaced at build time, so this branch is tree-shaken out of production —
  // and dev is client-only, so there's no hydration step there to mismatch.
  const origin =
    import.meta.env.DEV && typeof window !== 'undefined'
      ? window.location.origin
      : import.meta.env.VITE_PUBLIC_ORIGIN
  const redirect = `${origin}/patient`
  return `${ACCOUNT_PORTAL}${path}?redirect_url=${encodeURIComponent(redirect)}`
}

export const signInUrl = (): string => portalUrl('/sign-in')
export const signUpUrl = (): string => portalUrl('/sign-up')
